module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Abend")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Purpurschimmer tränket"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Rebenhügel."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nTiefer und tiefer senket"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nihre dunklen Flügel"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Nacht."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nLautlos fallen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSchleier herab auf Schleier."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWolkenpilger wallen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nferne zur Sonnenscheidefeier."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSacht"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwecket ein Hauch in der Bäume"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nlautlosen Wipfeln die Träume."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEh wir's gedacht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nhat sie mit bleichem Munde"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ngetrunken das Gold der Abendstunde:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie alte Nacht.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5729104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0009.vue
// module id = 81
// module chunks = 0